module.exports = __webpack_public_path__ + "media/t_layout.5cba4b0b.mp4";